(function() {
  const e = {
    containerSelector: '.variant-properties-container[data-auto-switch="true"]',
    propertiesSelector: '.variant-properties',
    optionTitleSelector: 'h5',
    eanPrefix: 'ean_',
    debug: false,
    includeOutOfStock: true,
    allowDirectVariantSelection: true
  };

  // Détection format optimisé
  const detectOptimizedFormat = () => {
    return document.querySelector('[data-optimization="lcp-critical-path"]') !== null;
  };
  
  const t = {
    initialized: false,
    lastActiveVariantId: null,
    lastOptionState: null,
    variantDataById: {},
    allProductVariants: [],
    pollingInterval: null,
    domObserver: null
  };
  
  const n = () => {
    const n = document.getElementById('VariantPropertiesData');
    if (!n) {
      if (e.debug) console.warn('[EAN Patch] Tag VariantPropertiesData non trouvé');
      return false
    }
    if (!window.ShopifyAnalytics?.meta?.product?.variants) {
      if (e.debug) console.warn('[EAN Patch] ShopifyAnalytics.meta.product.variants non disponible');
      return false
    }
    try {
      let r = [];
      if (n.dataset && n.dataset.variants) {
        try {
          r = JSON.parse(n.dataset.variants)
        } catch (e) {
          r = JSON.parse(n.textContent)
        }
      } else {
        r = JSON.parse(n.textContent)
      }
      if (e.debug) console.info('[EAN Patch] Données brutes chargées:', r);
      const o = Object.fromEntries(r.map(e => [String(e.id), e]));
      t.variantDataById = o;
      t.allProductVariants = r;
      window.ShopifyAnalytics.meta.product.variants.forEach(e => {
        const t = o[String(e.id)];
        if (!t) return;
        e.barcode = t.barcode;
        e.option1 = t.option1 || e.option1;
        e.option2 = t.option2 || e.option2;
        e.option3 = t.option3 || e.option3;
        e.available = typeof t.available !== 'undefined' ? t.available : e.available
      });
      if (e.debug) {
        console.info('[EAN Patch] Données injectées dans ShopifyAnalytics.meta');
        console.info('[EAN Patch] Nombre de variantes au total:', r.length);
        console.info('[EAN Patch] Nombre de variantes disponibles:', r.filter(e => e.available === true).length)
      }
      return true
    } catch (t) {
      console.warn('[EAN Patch] Erreur d\'analyse JSON :', t);
      return false
    }
  };
  
  const r = e => {
    const t = document.getElementById('addToCartBis');
    if (!t || !e) {
      if (e.debug) console.log('[ATC Bis] Bouton ou variante non trouvé');
      return
    }
    let n = false;
    if (typeof e.available !== 'undefined') {
      n = e.available
    } else {
      const r = t.variantDataById[String(e.id)];
      if (r && typeof r.available !== 'undefined') {
        n = r.available
      } else {
        const r = window.ShopifyAnalytics?.meta?.product?.variants?.find(t => String(t.id) === String(e.id));
        if (r && typeof r.available !== 'undefined') {
          n = r.available
        }
      }
    }
    const r = t.querySelector('span');
    if (r) {
      r.textContent = n ? 'Ajouter au panier' : 'Épuisé'
    }
    t.disabled = !n;
    const o = ['btn', 'btn-atc', 'add-to-cart-bundle'];
    const a = n ? ['addtocart-skake'] : ['disabled', 'addToCart', 'add-to-cart', 'no-stock'];
    t.className = o.join(' ');
    a.forEach(e => t.classList.add(e));
    if (e.debug) {
      console.log('[ATC Bis] Bouton mis à jour :', {
        id: e.id,
        available: n,
        classList: t.className,
        disabled: t.disabled
      })
    }
  };
  
  const o = t => {
    let n = t.querySelector('.variant-properties-fallback');
    if (!n) {
      n = document.createElement('div');
      n.className = 'variant-properties-fallback';
      n.style.cssText = 'padding: 1rem; background: #f9f9f9; border: 1px dashed #ccc; margin-top: 1rem;';
      n.innerText = 'Aucune information technique disponible pour cette sélection.';
      t.appendChild(n)
    }
    n.style.display = ''
  };
  
  const a = e => {
    const t = e.querySelector('.variant-properties-fallback');
    if (t) t.style.display = 'none'
  };
  
  const i = () => {
    if (e.allowDirectVariantSelection) {
      const n = new URLSearchParams(window.location.search);
      const r = n.get('variant');
      if (r) {
        const n = window.ShopifyAnalytics?.meta?.product?.variants?.find(e => String(e.id) === String(r));
        if (n) {
          if (e.debug) console.log('[Active Variant] Trouvée via URL:', n);
          return n
        }
        if (t.allProductVariants.length > 0) {
          const n = t.allProductVariants.find(e => String(e.id) === String(r));
          if (n) {
            if (e.debug) console.log('[Active Variant] Trouvée via cache:', n);
            return n
          }
        }
      }
    }
    const n = document.querySelector('select[name="id"], input[name="id"]:checked');
    if (n) {
      const r = n.value;
      const o = window.ShopifyAnalytics?.meta?.product?.variants?.find(e => String(e.id) === String(r));
      if (o) {
        if (e.debug) console.log('[Active Variant] Trouvée via sélecteur:', o);
        return o
      }
      if (t.allProductVariants.length > 0) {
        const o = t.allProductVariants.find(e => String(e.id) === String(r));
        if (o) {
          if (e.debug) console.log('[Active Variant] Trouvée via cache et sélecteur:', o);
          return o
        }
      }
    }
    if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
      const n = window.ShopifyAnalytics.meta.selectedVariantId;
      const r = window.ShopifyAnalytics?.meta?.product?.variants?.find(e => String(e.id) === String(n));
      if (r) {
        if (e.debug) console.log('[Active Variant] Trouvée via ShopifyAnalytics:', r);
        return r
      }
      if (t.allProductVariants.length > 0) {
        const r = t.allProductVariants.find(e => String(e.id) === String(n));
        if (r) {
          if (e.debug) console.log('[Active Variant] Trouvée via cache et ShopifyAnalytics:', r);
          return r
        }
      }
    }
    if (window.ShopifyAnalytics?.meta?.product?.variants?.length > 0) {
      const t = window.ShopifyAnalytics.meta.product.variants[0];
      if (e.debug) console.log('[Active Variant] Utilisation de la première variante par défaut:', t);
      return t
    }
    if (e.debug) console.warn('[Active Variant] Aucune variante active trouvée');
    return null
  };

  // Création dynamique de blocs
  const createVariantBlock = (ean, content, options) => {
    const container = document.querySelector(e.containerSelector);
    if (!container) return null;

    const lazyLoader = container.querySelector('.variant-lazy-loader');
    if (!lazyLoader) return null;

    // Vérifier si le bloc existe déjà
    let existingBlock = container.querySelector(`[data-variant-id="${ean}"]`);
    if (existingBlock) {
      return existingBlock;
    }

    // Créer un nouveau bloc
    const newBlock = document.createElement('div');
    newBlock.className = 'variant-properties';
    newBlock.setAttribute('data-variant-id', ean);
    if (options) {
      newBlock.setAttribute('data-options', options);
    }
    newBlock.innerHTML = content;
    newBlock.style.display = 'none';

    lazyLoader.appendChild(newBlock);

    if (e.debug) {
      console.log('[Variant Block] Nouveau bloc créé:', {
        ean: ean,
        options: options,
        hasContent: content.length > 0
      });
    }

    return newBlock;
  };
  
  // Mapping ID Shopify → EAN
  const getEanFromShopifyId = (shopifyId) => {
    const shopifyVariants = window.ShopifyAnalytics?.meta?.product?.variants || [];
    const variant = shopifyVariants.find(v => String(v.id) === String(shopifyId));
    return variant?.barcode || null;
  };

  const l = (n = null) => {
    const d = document.querySelector(e.containerSelector);
    if (!d) {
      if (e.debug) console.log('[variant-properties] Aucun conteneur trouvé, abandon');
      return
    }
    
    if (!n) {
      n = i()
    }
    if (!n) {
      if (e.debug) console.log('[variant-properties] Aucune variante trouvée, abandon');
      return
    }
    
    if (t.lastActiveVariantId === String(n.id)) {
      if (e.debug) console.log('[variant-properties] Variante déjà active, mise à jour du bouton uniquement');
      r(n);
      return
    }
    
    t.lastActiveVariantId = String(n.id);
    
    if (typeof n.available === 'undefined') {
      const e = t.variantDataById[String(n.id)];
      if (e && typeof e.available !== 'undefined') {
        n.available = e.available
      } else {
        const e = window.ShopifyAnalytics?.meta?.product?.variants?.find(e => String(e.id) === String(n.id));
        if (e && typeof e.available !== 'undefined') {
          n.available = e.available
        }
      }
    }
    
    if (e.debug) {
      console.groupCollapsed('[variant-properties] Mise à jour pour variante');
      console.log('variantId:', n.id);
      console.log('barcode:', n.barcode);
      console.log('title:', n.title);
      console.log('available:', n.available);
      console.log('options:', [n.option1, n.option2, n.option3]);
      console.log('fullVariant:', n);
      console.groupEnd()
    }
    
    // Mapping ID → EAN
    const c = n.barcode ? String(n.barcode).trim() : getEanFromShopifyId(n.id);
    const u = c ? e.eanPrefix + c : null;
    let p = null;
    
    // Recherche par EAN d'abord
    if (u) {
      p = d.querySelector(`[data-variant-id="${u}"]`);
      if (e.debug) {
        if (p) {
          console.log('[variant-properties] Bloc trouvé par EAN:', u)
        } else {
          console.log('[variant-properties] Aucun bloc trouvé avec data-variant-id=', u);
        }
      }
    }
    
    // NOUVEAU: Gestion mono-variante
    if (!p) {
      const criticalBlock = d.querySelector('.variant-properties.critical-variant');
      if (criticalBlock && (!n.option1 || n.title === 'Default Title')) {
        p = criticalBlock;
        if (e.debug) console.log('[variant-properties] Bloc mono-variante critique utilisé');
      }
    }
    
    
    // Lazy loading depuis JSON
    if (!p && u) {
      const lazyData = document.getElementById('VariantLazyData');
      if (lazyData) {
        try {
          const data = JSON.parse(lazyData.textContent);
          const content = data[u];
          
          if (content) {
            // Créer le bloc dynamiquement
            const options = [
              n.option1 ? `Couleur: ${n.option1}` : '',
              n.option2 ? `Modèle: ${n.option2}` : '',
              n.option3 ? `Taille: ${n.option3}` : ''
            ].filter(Boolean).join(', ');
            
            p = createVariantBlock(u, content, options);
            
            if (e.debug) {
              console.log('[variant-properties] Bloc créé depuis lazy data:', u);
            }
          }
        } catch (error) {
          console.error('[variant-properties] Erreur parsing lazy data:', error);
        }
      }
    }
    
    // Fallback par options textuelles
    if (!p && (n.option1 || n.option2 || n.option3)) {
      const optionString = [
        n.option1 ? `Couleur: ${n.option1}` : '', 
        n.option2 ? `Modèle: ${n.option2}` : '', 
        n.option3 ? `Taille: ${n.option3}` : ''
      ].filter(Boolean).join(', ');
      
      const s = Array.from(d.querySelectorAll(e.propertiesSelector));
      p = s.find(e => (e.dataset.options || '').trim() === optionString);
      
      if (e.debug) {
        if (p) {
          console.log('[variant-properties] Bloc trouvé par options:', optionString)
        } else {
          console.warn('[variant-properties] Aucun bloc trouvé avec options:', optionString);
          console.log('[variant-properties] Options disponibles:');
          s.forEach((e, t) => {
            console.log(`Bloc ${t+1}:`, e.dataset.options || 'Sans options')
          })
        }
      }
    }
    
    // S'assurer que le container principal est visible
    if (d) {
      d.style.display = 'block';
      d.style.visibility = 'visible';
      if (e.debug) console.log('[variant-properties] Container forcé visible');
    }
    
    // CORRECTION CRITIQUE: S'assurer que le lazy-loader est visible
    const lazyLoader = d.querySelector('.variant-lazy-loader');
    if (lazyLoader) {
      lazyLoader.style.display = 'block';
      lazyLoader.style.visibility = 'visible';
      if (e.debug) console.log('[variant-properties] Lazy loader rendu visible');
    }
    
    // Affichage du bloc trouvé ou fallback
    const s = Array.from(d.querySelectorAll(e.propertiesSelector));
    if (p) {
      // CORRECTION: Masquage agressif avec classes active
      s.forEach(variant => {
        if (variant === p) {
          variant.style.display = 'block';
          variant.style.visibility = 'visible';
          variant.style.opacity = '1';
          variant.classList.add('active');
        } else {
          variant.style.display = 'none';
          variant.style.visibility = 'hidden';
          variant.style.opacity = '0';
          variant.classList.remove('active');
        }
      });
      
      a(d);
      
      // Masquer skeleton si format optimisé
      const skeleton = document.querySelector('.variant-skeleton');
      if (skeleton && detectOptimizedFormat()) {
        skeleton.style.display = 'none';
      }
      
      if (e.debug) console.log('[variant-properties] Bloc affiché:', p)
    } else {
      // CORRECTION: Masquage agressif du fallback aussi
      s.forEach(variant => {
        variant.style.display = 'none';
        variant.style.visibility = 'hidden';
        variant.style.opacity = '0';
        variant.classList.remove('active');
      });
      
      o(d);
      if (e.debug) console.log('[variant-properties] Aucun bloc correspondant trouvé, fallback affiché')
    }
    
    r(n)
  };

  // Détection changement variante compatible sandboxed
  const initVariantChangeDetection = () => {
    let lastVariantId = null;
    let lastOptionState = null;
    
    const checkVariantChange = () => {
      // Méthode 1: Vérifier URL
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get('variant');
      
      // Méthode 2: Vérifier sélecteur principal
      const variantSelect = document.querySelector('select[name="id"]');
      const selectVariantId = variantSelect?.value;
      
      // Méthode 3: Vérifier radio buttons/swatches
      const checkedInput = document.querySelector('input[name="id"]:checked');
      const checkedVariantId = checkedInput?.value;
      
      // Méthode 4: Vérifier options individuelles
      const option1Input = document.querySelector('input[name*="option"]:checked, select[name*="option"] option:checked');
      const currentOption1 = option1Input?.value || option1Input?.textContent;
      
      const currentOptionState = JSON.stringify({
        option1: currentOption1,
        url: urlVariantId,
        select: selectVariantId,
        checked: checkedVariantId
      });
      
      const activeVariantId = urlVariantId || selectVariantId || checkedVariantId;
      
      // Détecter changement
      const variantChanged = activeVariantId && activeVariantId !== lastVariantId;
      const optionChanged = currentOptionState !== lastOptionState;
      
      if (variantChanged || optionChanged) {
        lastVariantId = activeVariantId;
        lastOptionState = currentOptionState;
        
        if (e.debug) {
          console.log('[variant-properties] Changement détecté:', {
            variantId: activeVariantId,
            option1: currentOption1,
            method: urlVariantId ? 'URL' : selectVariantId ? 'SELECT' : checkedVariantId ? 'RADIO' : 'OPTION'
          });
        }
        
        // Déclencher la mise à jour avec un délai pour éviter les conflits
        setTimeout(() => l(), 50);
      }
    };
    
    // Polling léger pour détecter les changements
    if (t.pollingInterval) {
      clearInterval(t.pollingInterval);
    }
    t.pollingInterval = setInterval(checkVariantChange, 300);
    
    // Observer DOM pour réactivité immédiate
    if (t.domObserver) {
      t.domObserver.disconnect();
    }
    
    t.domObserver = new MutationObserver(() => {
      setTimeout(checkVariantChange, 50);
    });
    
    t.domObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'selected', 'checked', 'data-variant-id']
    });
    
    // Vérification initiale
    setTimeout(checkVariantChange, 100);
    
    if (e.debug) {
      console.log('[variant-properties] Détection changement variante initialisée (polling + observer)');
    }
  };
  
  const d = () => {
    if (t.initialized) return;
    const r = document.querySelector(e.containerSelector);
    if (!r) {
      if (e.debug) console.log('[variant-properties] Aucun conteneur de propriétés trouvé, initialisation annulée');
      return
    }
    if (e.debug) console.log('[variant-properties] Initialisation du module...');

    // Initialisation spéciale pour format optimisé
    if (detectOptimizedFormat()) {
      setTimeout(() => {
        const skeleton = document.querySelector('.variant-skeleton');
        if (skeleton) skeleton.style.display = 'none';
        const container = document.querySelector('.variant-properties-container[data-critical-ean]');
        if (container) container.style.display = 'block';
      }, 300);
    }
    
    const o = n();
    if (!o && e.debug) {
      console.warn('[variant-properties] Impossible de patcher les données EAN')
    }
    
    // Affichage initial
    l();
    
    // Remplacement des événements par polling
    initVariantChangeDetection();
    
    // Observer les mutations sur les formulaires produit
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const formObserver = new MutationObserver(() => {
        setTimeout(() => l(), 20);
      });
      
      formObserver.observe(productForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'selected', 'checked']
      });
      
      if (e.debug) console.log('[variant-properties] Observateur formulaire initialisé');
    }
    
    // Gestion popstate pour navigation historique
    window.addEventListener('popstate', () => {
      if (e.debug) console.log('[variant-properties] Événement popstate détecté');
      setTimeout(l, 50)
    });
    
    t.initialized = true;
    if (e.debug) console.log('[variant-properties] Initialisation terminée avec nouvelle logique polling')
  };
  
  // Nettoyage au déchargement de la page
  const cleanup = () => {
    if (t.pollingInterval) {
      clearInterval(t.pollingInterval);
    }
    if (t.domObserver) {
      t.domObserver.disconnect(); 
    }
  };
  
  window.addEventListener('beforeunload', cleanup);
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(d, 10)
    })
  } else {
    setTimeout(d, 10)
  }
  
  window.addEventListener('load', () => {
    if (!t.initialized) {
      setTimeout(d, 100)
    }
    setTimeout(l, 200)
  })
})();